module.exports = __webpack_public_path__ + "86f7baae8a879432edc4fe9885a2480d.pdf";